import SimpleBar from 'simplebar'

$('.list--downloads input[type="checkbox"]').on('change', function (e) {
	e.preventDefault()

	var downloadsLength = $('.list--downloads input[type="checkbox"]').filter(':checked').length

	$('span.downloads--number').html(downloadsLength)
})

var scrollbar

$('.scroll')
	.not('.section--map .scroll,.nav--main .scroll')
	.each(function (index, el) {
		scrollbar = new SimpleBar(el, { autoHide: false })
	})

/*if($('.scroll').length){
	var scrollbar = new SimpleBar($('.scroll')[0], { autoHide: false });
}
*/
$('.nav--panels a').on('click', function (e) {
	e.preventDefault()

	scrollbar.getScrollElement().scrollTop = 0

	$('.nav--panels a').removeClass('tab--active')
	$(this).addClass('tab--active')

	var panel = $(this).attr('href')

	if (panel == '#panel--all') {
		$('.panel').addClass('panel--active').attr('aria-hidden', 'false')
	} else {
		$('.panel').removeClass('panel--active').attr('aria-hidden', 'true')
		$(panel).addClass('panel--active').attr('aria-hidden', 'false')
	}
})
